import React, { useState } from "react";
import { Form, Input, Button } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { VscEyeClosed, VscEye } from "react-icons/vsc";
import axios from "axios";
import toast from "react-hot-toast";
import { setToken } from "../../../utils/token";
import "./style.css";
import AuthImage from "../../../assets/images/homebg.png";

const SignIn = () => {
  const [loading, setLoading] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const navigate = useNavigate();

  // Handle Login
  const handleLogin = async (values) => {
    const { username, password } = values;
    try {
      setLoading(true);
      const res = await axios.post(
        "https://api.headend.chanels.io/public/auth/login",
        { username, password },
        { headers: { Version: "0.1" } }
      );

      toast.success("Logged in successfully.");
      await setToken("spiral_token", res.data.sessionid);
      await setToken("spiral_user", username);
      window.location.pathname = "/";
    } catch (err) {
      toast.error(err.response?.data?.response || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-screen w-100 h-100 bg">
      <div className="container-fluid p-0 m-0">
        <div className="row d-flex align-items-center justify-content-center">
          <div className="col-sm-12 col-md-5 col-lg-5 col-xl-5 col-xxl-5">
            <div className="form-cover d-flex align-items-center justify-content-center">
              <div className="form-content shadow bg-white rounded-3 p-4">
                <div className="form-title text-center">
                  Chanels: <br />
                  Headend & Meter Data Management
                </div>
                <hr />
                <Form
                  size="large"
                  className=""
                  layout="vertical"
                  onFinish={handleLogin}
                >
                  {/* Username Field */}
                  <Form.Item
                    label="Username"
                    name="username"
                    rules={[
                      {
                        required: true,
                        message: "Please enter your username!",
                      },
                    ]}
                  >
                    <Input placeholder="Enter your username" />
                  </Form.Item>

                  {/* Password Field */}
                  <Form.Item
                    label="Password"
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: "Please enter your password!",
                      },
                    ]}
                  >
                    <Input.Password
                      placeholder="Enter your password"
                      iconRender={(visible) =>
                        visible ? (
                          <VscEyeClosed size={20} color="grey" />
                        ) : (
                          <VscEye size={20} color="grey" />
                        )
                      }
                      visibilityToggle
                    />
                  </Form.Item>

                  {/* Submit Button */}
                  <Form.Item>
                    <Button
                      className="bg-black border-none"
                      type="primary"
                      htmlType="submit"
                      block
                      loading={loading}
                    >
                      Sign In
                    </Button>
                  </Form.Item>
                </Form>

                <div className="text-center mt-2 d-none">
                  <Link to="/forgot-password">Forgot password?</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
